import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/logo-text-dark.png'
import _imports_1 from '@/assets/img/logo-text.png'
import _imports_2 from '@/assets/img/news/lang-dark.png'
import _imports_3 from '@/assets/img/news/lang-light.png'
import _imports_4 from '@/assets/img/news/news-up.png'
import _imports_5 from '@/assets/img/news/news-down.png'
import _imports_6 from '@/assets/img/news/news-web.png'
import _imports_7 from '@/assets/img/news/news-x.png'
import _imports_8 from '@/assets/img/news/news-fb.png'
import _imports_9 from '@/assets/img/news/news-ins.png'
import _imports_10 from '@/assets/img/news/news-app.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "pageHead" }
const _hoisted_3 = { class: "phLeft" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  class: "pageMain"
}
const _hoisted_9 = {
  key: 2,
  class: "pageMain"
}
const _hoisted_10 = { class: "pmTitle" }
const _hoisted_11 = { class: "pmInfo" }
const _hoisted_12 = { class: "infoUser" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "infoTime" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "pmBtn" }
const _hoisted_17 = { class: "pageFoot" }
const _hoisted_18 = { class: "pfText" }
const _hoisted_19 = { class: "pfLink" }
const _hoisted_20 = { class: "pfRight" }
const _hoisted_21 = { class: "prTxt" }

import { useDark } from '@vueuse/core';
import { onMounted, ref, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';
import useOpenApp from '@/hooks/useOpenApp';
import { getNewsInfoApi, NewsInfo } from '@/api/news';
import dayjs from 'dayjs';
import PageError from '@/components/page-error.vue'
import LangPopup from './components/LangPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const avatarRef = useTemplateRef('avatarRef')
const showLoad = ref(false)
const isShowPageError = ref(false)
const langOpen = ref<boolean>(false);

const { openApp } = useOpenApp();

const newsInfo = ref<NewsInfo>();
const getNews = async () => {
  try {
    let res = await getNewsInfoApi(route.query.id as string);
    showLoad.value = false;
    if (res.value?.code == 0) {
      console.log(res.value.result)
      newsInfo.value = res.value.result;
    } else {
      isShowPageError.value = true;
    }
  } catch (error) {
    showLoad.value = false;
    isShowPageError.value = true;
  }
};

const isDark = useDark({
  selector: 'html',
  attribute: 'data-theme',
  valueDark: 'dark',
  valueLight: 'light',
});

const onImgError = () => {
  if (avatarRef.value) {
    avatarRef.value.src = require('@/assets/img/envo-icon-post/defaultTx.png')
  }
}

const handleJump = (type: number) => {
  let url = '';
  switch (type) {
    case 1:
      url = 'https://www.envo.work/';
      break;
    case 2:
      url = 'https://x.com/Envo_Official';
      break;
    case 3:
      url = 'https://www.facebook.com/people/Envo-Social/61560347969092/';
      break;
    case 4:
      url = 'https://www.instagram.com/envo_social/#';
      break;
    default:
      break;
  }
  window.open(url, '_blank')
}

onMounted(() => {
  showLoad.value = true;
  // if (route.query?.id) {
  //   openApp();
  // }
  getNews();
});

return (_ctx: any,_cache: any) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(isDark))
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ]),
      _createElementVNode("div", {
        class: "phRight",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (langOpen.value = true))
      }, [
        (_unref(isDark))
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : (_openBlock(), _createElementBlock("img", _hoisted_7))
      ])
    ]),
    (showLoad.value)
      ? (_openBlock(), _createBlock(_component_a_skeleton, {
          key: 0,
          style: {"flex":"1"},
          active: ""
        }))
      : _createCommentVNode("", true),
    (isShowPageError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(PageError)
        ]))
      : _createCommentVNode("", true),
    (!showLoad.value && !isShowPageError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(newsInfo.value?.title), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                ref_key: "avatarRef",
                ref: avatarRef,
                src: newsInfo.value?.sourceLogo,
                alt: "",
                onError: onImgError
              }, null, 40, _hoisted_13),
              _createElementVNode("span", null, _toDisplayString(newsInfo.value?.sourceName), 1)
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(dayjs)(newsInfo.value?.publishDate).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _createElementVNode("div", {
            class: "pmText",
            innerHTML: newsInfo.value?.content
          }, null, 8, _hoisted_15),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "btnItem",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('利好')) + " " + _toDisplayString(parseFloat((+(newsInfo.value?.goodRate || 0) * 100).toFixed(2))) + "%", 1),
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_4,
                alt: ""
              }, null, -1))
            ]),
            _createElementVNode("div", {
              class: "btnItem",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('利空')) + " " + _toDisplayString(parseFloat((+(newsInfo.value?.badRate || 0) * 100).toFixed(2))) + "%", 1),
              _cache[10] || (_cache[10] = _createElementVNode("img", {
                src: _imports_5,
                alt: ""
              }, null, -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pfLogo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('全球領先的一站式Web3社交生態平臺')), 1),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("img", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleJump(1))),
          src: _imports_6,
          alt: ""
        }),
        _createElementVNode("img", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleJump(2))),
          src: _imports_7,
          alt: ""
        }),
        _createElementVNode("img", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleJump(3))),
          src: _imports_8,
          alt: ""
        }),
        _createElementVNode("img", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleJump(4))),
          src: _imports_9,
          alt: ""
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createTextVNode(_toDisplayString(_ctx.$t('使用条款')) + " · ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('隐私政策')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('和')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('用户协议')), 1)
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "prTxt" }, "2025 © Envo. Terms & Privacy Policy", -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "pageApp",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
    }, [
      _cache[13] || (_cache[13] = _createElementVNode("img", {
        src: _imports_10,
        alt: ""
      }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('在App内阅读')), 1)
    ]),
    _createVNode(LangPopup, {
      show: langOpen.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((langOpen).value = $event))
    }, null, 8, ["show"])
  ]))
}
}

})